/**
 * 基础信息
 */

import { useState, useEffect } from 'react';
import {
    Row,
    Col,
    Divider,
    theme,
    Tag,
    ColorPicker,
    Space,
    Button,
    Radio,
    message,
    Badge,
} from 'antd';
import $ from 'jquery';
import {
    AddRequestHeaders,
} from '../../incs/FunHelper';
import CNF from '../../incs/Config.js';


const BasicInfo = (props) => {
    const [messageApi, contextHolder] = message.useMessage();

    const [basicinfo, setBasicinfo] = useState({});

    const {
        token: { colorPrimary },
    } = theme.useToken();

    const [themeColor, setThemeColor] = useState(colorPrimary);
    const [isDisplayTableBorder, setIsDisplayTablesBorder] = useState(0);

    useEffect(() => {
        // 初始化账户基础信息
        $.ajax({
            url: `${CNF.api}users/basicinfo`,
            headers: AddRequestHeaders(),
            type: 'GET', success: function (data) {
                if (data.res === 0) {
                    setBasicinfo(data.dat);
                }
            }
        });
    }, []);

    const save = () => {
        // 保存基础设置信息
        $.ajax({
            url: `${CNF.api}users/basicinfo`,
            headers: AddRequestHeaders(),
            type: 'PATCH',
            dataType: 'JSON',
            data: JSON.stringify({
                'theme_color': themeColor,
                'is_display_table_border': isDisplayTableBorder,
            }),
        }).done(function (data) {
            if (data.res === 0) {
                messageApi.success(data.msg, CNF.messageDuration);
            } else {
                messageApi.error(data.msg, CNF.messageDuration);
            }
        }).fail(function (data) {
            messageApi.error(data.responseJSON.detail, CNF.messageDuration);
        });
    }

    return (<div style={{ height: '100%', padding: '0 30px' }}>
        {contextHolder}
        <h3>{props.m > 0 ? CNF.navUserItems[props.m - 1].name : ''}</h3>
        <Divider style={{ margin: 0, borderColor: colorPrimary }} />
        <Row style={{ marginTop: '20px' }}>
            <Col span={12}>
                <Col span={24}><p><label>组织: </label>{basicinfo.org_info_name}</p></Col>
                <Col span={24}><p><label>部门: </label>{basicinfo.department}</p></Col>
                <Col span={24}><p><label>岗位: </label>{basicinfo.job}</p></Col>
                <Col span={24}><p><label>性别: </label><Tag color={colorPrimary}>{basicinfo.sex}</Tag></p></Col>
                <Col span={24}><p><label>出生日期: </label>{basicinfo.birth_date}</p></Col>
                <Col span={24}><p><label>能力类型: </label>{basicinfo.ability_type}</p></Col>
                <Col span={24}><p><label>教育背景: </label>{basicinfo.edu_background}</p></Col>
                <Col span={24}><p><label>家庭住址: </label>{basicinfo.address}</p></Col>
                <Col span={24}><p><label>入职日期: </label>{basicinfo.entry_date}</p></Col>
                <Col span={24}><p><label>身份证号: </label>{basicinfo.idcard}</p></Col>
                {/* 主题设置 */}
                <Col span={24}>
                    <Space>
                        <p><label>主题设置: </label></p>
                        <ColorPicker
                            disabledAlpha
                            presets={[{ label: '推荐主题', colors: CNF.themeColors, key: '推荐主题' }]}
                            defaultValue={colorPrimary}
                            onChange={(value) => {
                                setThemeColor(value.toHexString());
                                props.setThemeColor(value.toHexString());
                            }}
                        />
                    </Space>
                </Col>
                {/* 表格边框 */}
                <Col span={24}>
                    <Space>
                        <p><label>表格边框: </label></p>
                        <Radio.Group
                            value={isDisplayTableBorder}
                            options={[
                                { value: 0, label: '否' },
                                { value: 1, label: '是' },
                            ]}
                            onChange={(e) => setIsDisplayTablesBorder(e.target.value)}
                        />
                    </Space>
                </Col>
                <Col span={24}><p><Button color='primary' variant='solid' onClick={() => save()}>保存</Button></p></Col>
                <Col span={24} style={{ fontSize: 11 }}><Badge color={colorPrimary} status='processing' size='small' /> 备注: 保存后重新登录使配置生效</Col>
            </Col>
        </Row>
    </div>);
}

export default BasicInfo